import { COMPANY, FUND, INDEX, INDICATOR, MODEL_PORTFOLIO, SECURITYLIST_GROUP_MULTI, } from 'Angular/constants/core.constants';
import { IndicatorListViewInOption, SecurityListViewInOption } from './enums/security-list-view-in-option.enum';
export const ADD = 'add';
export const INTERSECT = 'intersect';
export const EXCLUDE = 'exclude';
// Security list menu constants
export const SECURITYLIST_MENU_ORDER_MAP = {
    [SECURITYLIST_GROUP_MULTI]: [
        'Watchlists',
        'Fund Screens',
        'Stock Screens',
        'Comp Tables',
        'Timeseries Tables',
        'Model Portfolio Holdings',
        'Portfolio Holdings',
        'Quickflow List',
    ],
    [COMPANY]: [
        'Types',
        'Style',
        'Exchanges',
        'Indices',
        'NAICS Sectors',
        'NAICS Industries',
        'Events',
        'Dividend Policies',
        'Performance',
        'GICS Sectors',
        'Consensus Recommendation',
        'Headquarters Region',
        'Incorporation Region',
        'Currency Code',
        'Investment Firms',
        'Investment Strategies',
        'Delisted Equities',
        'YCharts Proprietary',
    ],
    [FUND]: [
        'Types',
        'Category Name',
        'Peer Group Name',
        'Styles (Morn)',
        'Styles',
        'Broad Category',
        'Broad Asset Class',
        'Prospectus Benchmark Index (Morn)',
        'Prospectus Benchmark Index',
        'Brokerage Availability',
        'Domicile',
        'Currency Code',
        'Share Class',
        'Fund Family (Morn)',
        'Fund Family',
        'Fund Manager (Morn)',
        'Fund Manager',
        'Fund Focus (Holdings Based) (Morn)',
        'Fund Focus (Holdings Based)',
        'Prospectus Objective',
        'Legal Structure',
        'Attributes (Morn)',
        'Attributes',
        'Events',
        'Dividend Policies',
        'Performance',
        'Delisted Funds',
        'YCharts Proprietary',
    ],
    [INDEX]: [],
    [INDICATOR]: ['YCharts Proprietary'],
    [MODEL_PORTFOLIO]: [],
};
export const SECURITY_LIST_VIEW_IN_LABEL = 'View in...';
export const SECURITY_LIST_VIEW_IN_DROPDOWN_OPTIONS = {
    type: 'option',
    label: SECURITY_LIST_VIEW_IN_LABEL,
    value: null,
    sublist: [
        { label: 'Stock Screener', value: SecurityListViewInOption.VIEW_IN_STOCK_SCREENER },
        { label: 'Fund Screener', value: SecurityListViewInOption.VIEW_IN_FUND_SCREENER },
        { label: 'Comp Tables', value: SecurityListViewInOption.VIEW_IN_COMP_TABLES },
        { label: 'Timeseries Tables', value: SecurityListViewInOption.VIEW_IN_TIMESERIES },
        { label: 'News', value: SecurityListViewInOption.VIEW_IN_NEWS },
        { label: 'Technical Chart', value: SecurityListViewInOption.VIEW_IN_TECH_CHART },
        { label: 'Fundamental Chart', value: SecurityListViewInOption.VIEW_IN_FUND_CHART },
        { label: 'Scatter Plot', value: SecurityListViewInOption.VIEW_IN_SCATTER_PLOT },
        { label: 'Model Portfolio', value: SecurityListViewInOption.VIEW_IN_MODEL_PORTFOLIO },
    ],
};
export const INDICATOR_LIST_VIEW_IN_DROPDOWN_OPTIONS = {
    type: 'option',
    label: 'View in...',
    value: null,
    sublist: [
        { label: 'Timeseries Tables', value: IndicatorListViewInOption.VIEW_IN_TIMESERIES },
        { label: 'Fundamental Chart', value: IndicatorListViewInOption.VIEW_IN_FUND_CHART },
    ],
};
